import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Button,
    Divider
  , Table, TableHead, TableRow, TableCell, TableContainer, TableBody,
} from '@material-ui/core';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

import mockData from './data';
import moment from "moment";

const useStyles = makeStyles(() => ({
  root: {
    height: '100%'
  },
  content: {
    padding: 0,

  },
  image: {
    height: 35,
    width: 32
  },
  actions: {
    justifyContent: 'flex-end'
  },
  listItem:{
    textAlign:'right',
    paddingRight:20
  },
    tableContainer:{
        height:500
    }
}));

const LatestOrders = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  const [products] = useState(mockData);

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        subtitle={`${products.length} in total`}
        title="آخرین فروش های بوفه"
      />
      <Divider />
      <CardContent className={classes.content}>
          <TableContainer className={classes.tableContainer}>
          <Table stickyHeader>
              <TableHead>
                  <TableRow>
                      <TableCell align="center">محصول</TableCell>
                      <TableCell align="center" sortDirection="desc">
                         تعداد
                      </TableCell>
                      <TableCell align="center" sortDirection="desc">
                          هزینه
                      </TableCell>
                      <TableCell align="center">
                          شاگرد
                      </TableCell>
                  </TableRow>
              </TableHead>
              <TableBody className={classes.tableBody}>
                  {mockData.map(order => (
                      <TableRow
                          hover
                          key={order.id}
                      >
                          <TableCell align="center">
                              {order.product}
                          </TableCell>
                          <TableCell align="center">
                      {order.q}
                          </TableCell>
                          <TableCell align="center">{order.totalPrice}</TableCell>
                          <TableCell align="center">
                              {order.disciple}
                          </TableCell>
                      </TableRow>
                  ))}
              </TableBody>
          </Table>
          </TableContainer>
      </CardContent>
      <Divider />
      <CardActions className={classes.actions}>
        <Button
          color="primary"
          size="small"
          variant="text"
        >
        نمایش همه سفارشات <ArrowRightIcon />
        </Button>
      </CardActions>
    </Card>
  );
};

LatestOrders.propTypes = {
  className: PropTypes.string
};

export default LatestOrders;
